var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccordianArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94146 1.00331C7.79761 1.01975 7.66167 1.09592 7.55311 1.221L1.25188 8.40517C1.10865 8.55871 1.01863 8.78242 1.00251 9.02496C0.986698 9.26751 1.046 9.50845 1.16734 9.69166C1.28868 9.87527 1.46111 9.98632 1.64571 9.99875C1.83031 10.0112 2.01065 9.92499 2.14567 9.75901L7.99985 3.0868L13.854 9.75901C13.989 9.92499 14.1694 10.0116 14.354 9.99875C14.5386 9.98592 14.7113 9.87528 14.8327 9.69166C14.954 9.50805 15.0133 9.26751 14.9975 9.02496C14.9817 8.78242 14.8917 8.55871 14.7481 8.40517L8.44689 1.221C8.30761 1.06064 8.12514 0.982465 7.94146 1.00331Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordianArrow);
export default __webpack_public_path__ + "static/media/accordian-arrow.42ad3cf3c92c3c47eef1a8fc6966921b.svg";
export { ForwardRef as ReactComponent };